export default __webpack_public_path__ + "static/playlist-dark-mode-8a9dc168140710fc0235ad74404dde2a.mp4";